/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const commissionInputNameRegExp = new RegExp(".*\\S.*");
export const commissionInputPercentageMin = 0;
export const commissionInputPercentageMax = 100;
export const commissionInputPercentageMultipleOf = 0.01;

export const CommissionInput = zod.object({
  name: zod.string().min(1).regex(commissionInputNameRegExp),
  percentage: zod
    .number()
    .min(commissionInputPercentageMin)
    .max(commissionInputPercentageMax)
    .multipleOf(commissionInputPercentageMultipleOf),
});

export type CommissionInput = zod.input<typeof CommissionInput>;
export type CommissionInputOutput = zod.output<typeof CommissionInput>;
